export default __webpack_public_path__ + "static/media/solution_42.26ccb0b9.svg";